import { Link, useLocation } from "react-router-dom";
import { Compass, Ticket, Hotel, Wallet, Home } from "lucide-react";

const BottomNav = () => {
  const location = useLocation();
  
  const navItems = [
    { path: "/dashboard", icon: Home, label: "Home" },
    { path: "/trips", icon: Compass, label: "MyTrip" },
    { path: "/tickets", icon: Ticket, label: "MyTickets" },
    { path: "/bookings", icon: Hotel, label: "MyBookings" },
    { path: "/budget", icon: Wallet, label: "MyBudget" },
  ];

  return (
    <nav className="bottom-nav safe-area-bottom" data-testid="bottom-nav">
      <div className="mx-3 mb-2">
        <div className="flex justify-around items-center max-w-lg lg:max-w-2xl mx-auto bg-[#0d1321]/90 backdrop-blur-xl border border-white/[0.06] rounded-2xl py-2 lg:py-3 px-1 lg:px-4 shadow-2xl shadow-black/40">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            const Icon = item.icon;
            
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`bottom-nav-item flex flex-col items-center justify-center touch-target relative px-3 py-1.5 rounded-xl transition-all duration-300 ${
                  isActive ? "active bg-white/[0.06]" : "hover:bg-white/[0.03]"
                }`}
                data-testid={`nav-${item.label.toLowerCase()}`}
              >
                <div className="relative">
                  <Icon className={`w-5 h-5 lg:w-7 lg:h-7 mb-0.5 transition-all duration-300 ${
                    isActive ? 'text-cyan-400' : 'text-slate-500'
                  }`} />
                  {isActive && (
                    <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-cyan-400 shadow-lg shadow-cyan-400/50" />
                  )}
                </div>
                <span className={`text-[10px] lg:text-xs font-medium transition-colors duration-300 ${
                  isActive ? 'text-cyan-400' : 'text-slate-600'
                }`}>{item.label}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default BottomNav;
